import { type SimpleOption } from '@retailer-platform/shared-components/src/common/select/utils/select.types'
import { JsonParam, type QueryParamConfig } from 'serialize-query-params'

export const SimpleOptionsParam = {
  encode: JsonParam.encode,
  decode: JsonParam.decode,
} as QueryParamConfig<SimpleOption[]>
